import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../stores/useAuthStore';
import OTPInput from '../components/OTPInput';
import { useLocation } from 'react-router-dom';
import LMSHeader from '../components/LMSHeader';

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { resetPassword, isLoading, error } = useAuthStore();

  const [email, setEmail] = useState(location.state?.email || '');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [otp, setOtp] = useState('');

  const handleResetPassword = async (otpValue) => {
    if (password !== confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    const result = await resetPassword(email, otpValue, password);
    if (result.success) {
      alert('Password reset successfully. You can now log in.');
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex flex-col">
      <LMSHeader />
      <main className="flex-1 flex items-center justify-center p-4">
        <div className="max-w-md w-full  bg-white dark:bg-neutral-800 rounded-xl shadow-sm p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-neutral-900 dark:text-white mb-2">
              Reset Password
            </h1>
            <p className="text-neutral-600 dark:text-neutral-400 mb-6">
              {email}
            </p>
            <p className="text-neutral-600 dark:text-neutral-400">
              Enter the code we sent to your email and create a new password
            </p>
          </div>

          {error && (
            <div className="mb-6 p-3 bg-danger-100 dark:bg-danger-900/30 text-danger-700 dark:text-danger-300 rounded-lg text-sm">
              {error}
            </div>
          )}

          <div className="space-y-6">
            <div>
              <label htmlFor="email" className="hidden text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full hidden px-4 py-3 border border-neutral-300 dark:border-neutral-600 rounded-lg shadow-sm bg-white dark:bg-neutral-700 text-neutral-900 dark:text-white placeholder-neutral-500 dark:placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>

            <div className="text-center">
              <h2 className="text-xl font-semibold text-neutral-900 dark:text-white mb-2">
                Enter OTP
              </h2>
              <p className="text-neutral-600 dark:text-neutral-400 mb-4">
                We've sent a 6-digit code to your email
              </p>
              <div className="flex justify-center">
                <OTPInput
                  length={6}
                  onChange={setOtp}
                  onComplete={handleResetPassword}
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
                New Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 border border-neutral-300 dark:border-neutral-600 rounded-lg shadow-sm bg-white dark:bg-neutral-700 text-neutral-900 dark:text-white placeholder-neutral-500 dark:placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
                placeholder="••••••••"
              />
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
                Confirm New Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="w-full px-4 py-3 border border-neutral-300 dark:border-neutral-600 rounded-lg shadow-sm bg-white dark:bg-neutral-700 text-neutral-900 dark:text-white placeholder-neutral-500 dark:placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
                placeholder="••••••••"
              />
            </div>

            <button
              type="button"
              onClick={() => handleResetPassword(otp)}
              disabled={isLoading || !otp || password !== confirmPassword}
              className="w-full py-3 px-4 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-300 text-white font-medium rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-neutral-800 transition-all duration-200"
            >
              {isLoading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Resetting Password...
                </span>
              ) : (
                'Reset Password'
              )}
            </button>
          </div>

          <div className="mt-8 pt-6 border-t border-neutral-200 dark:border-neutral-700 text-center">
            <button
              onClick={() => navigate('/login')}
              className="text-sm text-primary-600 dark:text-primary-400 hover:underline"
            >
              Back to login
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ResetPassword;